import React from "react";
import { Col, Row } from "react-bootstrap";
import BastonIzquierda from "../../../assets/2024/startPage/BARRA-BASTON-DULCE-01.png";
import BastonDerecha from "../../../assets/2024/startPage/BARRA-BASTON-DULCE-02.png";

import Encuentra from "../../../assets/2024/startPage/ENCUENTRA-AQUI-TUS-PRODUCTOS.png";
import EncuentraEn from "../../../assets/2024/startPage/ENCUENTRA-AQUI-TUS-PRODUCTOS.png";

import BuyRappi from "../../../assets/2024/startPage/BOTON-COMPRA-RAPPI.png";
import BuyRappiEn from "../../../assets/2024/startPage//BOTON-COMPRA-RAPPI.png";

import BARA_VERTICAL from "../../../assets/BARA_VERTICAL.png";

import Galletas from "../../../assets/2024/startPage/GALLETAS-INFERIOR.png";
import Cascanueces from "../../../assets/2024/startPage/CASCANUECES.png";
import { useIntl } from "react-intl";
export const RedSection = () => {
  const intl = useIntl();
  return (
    <Row className="startPage__red">
      <Row
        className="justify-content-center min-content-height "
        style={{ paddingRight: "15%", paddingLeft: "15%" }}
      >
        <Col xs={4} className="text-right">
          {" "}
          <img
            src={intl.locale.includes("es") ? Encuentra : EncuentraEn}
            className="w-100"
            alt="Boton de comienzo"
          />
        </Col>
        <Col xs={1}>
          {" "}
          <img
            src={BARA_VERTICAL}
            alt="market"
            width="2rem"
            height="100%"
          ></img>{" "}
        </Col>
        <Col xs={4} className="text-start">
          {" "}
          <img
            src={intl.locale.includes("es") ? BuyRappi : BuyRappiEn}
            className="w-100"
            alt="Boton de comienzo"
          />
        </Col>
      </Row>
      <img
        src={BastonIzquierda}
        className="startPage__red__bastonIzquierda"
        alt="Baston dulce"
      />
      <img
        src={BastonDerecha}
        className="startPage__red__bastonDerecha"
        alt="Baston dulce"
      />
      <img
        src={Galletas}
        className="startPage__red__cookies"
        alt="Baston dulce"
      />
      <img
        src={Cascanueces}
        className="startPage__red__nut"
        alt="Baston dulce"
      />
    </Row>
  );
};
